export const PEOPLE_NAMES = {
    OWNER: 'owner',
    CREDIT_PEOPLE: 'creditPeople',
    MFO_PEOPLE: 'mfoPeople',
    ESIA: 'ESIA',
} as const;

export const marker = 'selection_frontend_profile_graphql';
